export default "__VITE_ASSET__DphCHQXI__";